/* eslint-disable */
import React from 'react'

function threeDigitFormat(val, placeholder = null) {
    try {
        if (val === null || val === undefined) {
            return placeholder
        }

        const num = Number(val)

        if (num >= 0 && num < 1) {
            return num.toFixed(3).slice(-4)
        }
        // Negative numbers? Meh
        return num.toFixed(3)
    } catch (e) {
        console.log('threeDigitFormat error', e, val) // eslint-disable-line no-console

        return val
    }
}

export default function HexLegend({
    type = 'pitch',
    settings,
    hex,
    radius,
    color,
    maxCount,
    chartOptions = {},
}) {
    let sizes = [maxCount, Math.floor(maxCount / 2), 1]

    if (Math.floor(maxCount / 2) == 1 && maxCount > 1) {
        sizes = [maxCount, 1]
    }
    if (maxCount === 1) {
        sizes = [1]
    }
    const legendType = chartOptions.type

    let translate = [settings.vizWidth * 1.05, 0]
    if (settings.orientation === 'portrait') {
        translate = [0, settings.vizWidth * 1.05]
    }

    if (color.domain && color.domain().length > 0) {
        const domain = color.domain().reverse()
        let yStart = 0

        let legendNameMultiple = 'Pitches'
        let legendNameOne = 'Pitch'
        if (type === 'field') {
            legendNameMultiple = 'Batted Balls'
            legendNameOne = 'Batted Ball'
        }
        return (
            <g
                key="hexLegend"
                id="hexLegend"
                transform={`translate(${translate})`}
            >
                {sizes.map((d, i) => {
                    yStart = i
                    return (
                        <g key={`g_${i}`}>
                            <path
                                key={`hexLegendPath_${i}`}
                                d={hex.hexagon(radius(d), [])}
                                transform={`translate(0, ${i * 28})`}
                                fill="#fff"
                                stroke="#000"
                                opacity={1}
                            />
                            <text
                                key={`hexLegendText_${i}`}
                                className="legend"
                                dy="4"
                                transform={`translate(20, ${i * 28})`}
                                fill="#000"
                                style={{ fontSize: `1rem` }}
                            >
                                {d}{' '}
                                {d === 1 ? legendNameOne : legendNameMultiple}
                            </text>
                        </g>
                    )
                })}
                {legendType !== 'totalPitches'
                    ? domain.map((d, i) => {
                          const first = i === 0
                          const last = domain.length - 1 === i
                          if (first) {
                              yStart++
                          }
                          yStart++

                          let translatePath = [0, yStart * 28]
                          let translateText = [20, yStart * 28]

                          if (settings.orientation === 'portrait') {
                              translatePath = [settings.vizWidth / 3, i * 28]
                              translateText = [
                                  settings.vizWidth / 3 + 20,
                                  i * 28,
                              ]
                          }

                          let value = d
                          if (legendType === 'ba' || legendType === 'woba') {
                              value = threeDigitFormat(value)
                          } else if (
                              legendType === 'avgExitVelocity' &&
                              first
                          ) {
                              value += '+ MPH'
                          } else if (legendType === 'avgExitVelocity' && last) {
                              value = `< ${value} MPH`
                          } else if (legendType === 'avgExitVelocity') {
                              value += ' MPH'
                          } else if (legendType === 'avgLaunchAngle') {
                              value += ' °'
                          } else if (legendType === 'kPercent') {
                              value += '%'
                          }

                          return (
                              <g key={`gAlt_${yStart}`}>
                                  <path
                                      key={`hexLegendPathAlt_${yStart}`}
                                      d={hex.hexagon(radius(maxCount), [])}
                                      transform={`translate(${translatePath})`}
                                      fill={color(d)}
                                      stroke="#000"
                                      opacity={1}
                                  />
                                  <text
                                      key={`hexLegendTextAlt_${yStart}`}
                                      className="legend"
                                      dy="4"
                                      transform={`translate(${translateText})`}
                                      fill="#000"
                                  >
                                      {value}
                                  </text>
                              </g>
                          )
                      })
                    : null}
            </g>
        )
    }
    return null
}
